// Option 2: Server Component Approach (Better Performance)
// components/PatentViewer.tsx

interface PatentViewerProps {
  patentId: string;
  width?: string;
  height?: string;
}

// This is a Server Component - runs at build time
export async function PatentViewer({ 
  patentId, 
  width = "400", 
  height = "auto" 
}: PatentViewerProps) {
  // Fetch data at build time
  let pages = [];
  let error = null;
  
  try {
    const response = await fetch('https://thedailydialectics.com/api/registry/directory/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        directory: `/pdfs/wipow/patents/${patentId}` 
      }),
      cache: 'force-cache'  // Cache for static generation
    });
    
    if (response.ok) {
      const data = await response.json();
      pages = data.result || [];
    } else {
      error = `Failed to fetch: ${response.statusText}`;
    }
  } catch (err) {
    error = err instanceof Error ? err.message : 'Unknown error';
  }
  
  // No hooks needed - this is all server-side!
  
  if (error) {
    return <div className="patent-error">Error: {error}</div>;
  }
  
  if (pages.length === 0) {
    return <div className="patent-empty">No pages found for {patentId}</div>;
  }
  
  return (
    <div className="patent-viewer">
      <h3>Patent {patentId} - {pages.length} Pages</h3>
      <div className="patent-gallery">
        {pages.map((page: any, i: number) => (
          <div key={i} className="patent-page">
            <img 
              src={page.image_url}
              alt={page.title || `${patentId} Page ${i + 1}`}
              width={width}
              height={height}
              loading="lazy"
            />
            {page.title && <p className="caption">{page.title}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}